import { createContext, useContext } from "react";
import type { PaymentTransaction } from "../../domain/entities/PaymentTransaction";
import type { PaymentMethod } from "../../domain/entities/PaymentMethod";
import type { Order } from "../../domain/entities/Order";

export type CheckoutRoute =
  | { name: "checkout" }
  | {
      name: "processing";
      transaction: PaymentTransaction;
      paymentMethodName: string;
      paymentMethod?: PaymentMethod | null;
      bookingCode?: string;
    }
  | {
      name: "success";
      transaction: PaymentTransaction;
      order: Order;
      paymentMethodName: string;
      paymentMethod?: PaymentMethod | null;
    };

export interface NavigationContextValue {
  route: CheckoutRoute;
  navigate: (route: CheckoutRoute) => void;
}

export const NavigationContext = createContext<NavigationContextValue | undefined>(undefined);

export const useNavigation = (): NavigationContextValue => {
  const context = useContext(NavigationContext);

  if (!context) {
    throw new Error("useNavigation must be used within an AppRouter provider");
  }

  return context;
};
